import {useRef, useEffect, useMemo} from 'react';
import React from 'react';
import * as echarts from 'echarts/core';
import {
    LineChart,
    ScatterChart,
    BarChart,
    PieChart,
    RadarChart,
    GraphChart,
    GaugeChart,
    BoxplotChart,
    ParallelChart,
    SankeyChart,
    PictorialBarChart,
    ThemeRiverChart,
    SunburstChart,
    HeatmapChart,
    TreemapChart,
    TreeChart
} from 'echarts/charts';
import {
    TooltipComponent,
    TitleComponent,
    LegendComponent,
    ToolboxComponent,
    GridComponent,
    DataZoomComponent
} from 'echarts/components';
import {LabelLayout, UniversalTransition} from 'echarts/features';
import {CanvasRenderer} from 'echarts/renderers';

import {ACUD_PRO_PREFIX} from '../../../_common/constants';

import '../index.less';

const CHART_PREFIX = `${ACUD_PRO_PREFIX}-chart`;

export interface ChartProps {
    containerWidth?: number | string;
    containerHeight?: number | string;
    chartWidth?: number | string;
    chartHeight?: number | string;
    option?: any;
}

// 注册必需的图表和组件
echarts.use([
    LineChart,
    ScatterChart,
    BarChart,
    PieChart,
    RadarChart,
    GraphChart,
    GaugeChart,
    BoxplotChart,
    ParallelChart,
    SankeyChart,
    PictorialBarChart,
    ThemeRiverChart,
    SunburstChart,
    HeatmapChart,
    TreemapChart,
    TreeChart,
    TooltipComponent,
    TitleComponent,
    LegendComponent,
    ToolboxComponent,
    GridComponent,
    CanvasRenderer,
    DataZoomComponent,
    LabelLayout,
    UniversalTransition
]);

const Chart = (props: ChartProps) => {
    const {
        containerWidth,
        containerHeight,
        chartWidth,
        chartHeight,
        option
    } = props;
    const chartRef = useRef(null);
    const chartInsRef = useRef(null);

    useEffect(() => {
        if (!chartInsRef.current) {
            let opt: any = {
                locale: 'ZH'
            };
            if (chartWidth) {
                opt.width = chartWidth;
            }
            if (chartHeight) {
                opt.height = chartHeight;
            }
            // 创建图表实例
            const chart = echarts.init(chartRef.current, null, opt);
            chartInsRef.current = chart as any;
            if (chartWidth === undefined && chartHeight === undefined) {
                const resizeObserver = new ResizeObserver(() => {
                    (chartInsRef.current as any).resize();
                });
                resizeObserver.observe(chartRef.current as any);
                return () => {
                    resizeObserver.disconnect();
                };
            }
        }
        else {
            if (chartWidth !== undefined || chartHeight !== undefined) {
                (chartInsRef.current as any).resize({
                    width: chartWidth,
                    height: chartHeight
                });
            }
        }
    }, [chartWidth, chartHeight]);

    const containerStyle = useMemo(() => {
        let cStyle: any = null;
        if (containerWidth) {
            cStyle = {width: containerWidth};
            if (containerHeight) {
                cStyle.height = containerHeight;
            }
        }
        else if (containerHeight) {
            cStyle = {height: containerHeight};
        }

        return cStyle;
    }, [containerWidth, containerHeight]);

    useEffect(() => {
        (chartInsRef?.current as any)?.setOption(option, true);
    }, [option]);

    return (
        <div className={`${CHART_PREFIX}-box`}>
            <div ref={chartRef} className={`${CHART_PREFIX}-box-content`} style={containerStyle}>
            </div>
        </div>
    );
};
export default Chart;